import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-html',
    templateUrl: './block-html.component.html',
})

export class BlockHTMLComponent extends BlockAbstractComponent implements OnInit {

}
